module.exports = __webpack_public_path__ + "img/Popup_bob_mobile.2e40cf0.png";